import { CHANGE_REASON } from "@/static/changeReasonEnum";
import { Expose } from "class-transformer";
import { IsNumber, IsOptional, IsString } from "class-validator";

export class CorrectionReasonTemporary {
  @IsOptional()
  @IsNumber()
  @Expose()
  internalChangeReasonId!: null | CHANGE_REASON;
  @IsOptional()
  @IsNumber()
  @Expose()
  changeReasonId!: null | number;
  @IsOptional()
  @IsString()
  @Expose()
  changeReasonDescription!: null | string;
  @IsOptional()
  @IsString()
  @Expose()
  formalCorrectionBefore!: string | null;
  @IsOptional()
  @IsString()
  @Expose()
  formalCorrectionAfter!: string | null;
}
